import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaArrowLeft } from 'react-icons/fa';
import '../styles/blogArticle.css';

const openWhatsApp = (msg) =>
  window.open(`https://wa.me/5519995910565?text=${encodeURIComponent(msg)}`, '_blank');

export default function DieselSoberaniaPage() {
  const [scrolled, setScrolled] = useState(0);

  useEffect(() => {
    const el = document.documentElement;
    const onScroll = () => setScrolled(el.scrollTop / (el.scrollHeight - el.clientHeight));
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Progress bar */}
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 2, background: '#dedad2', zIndex: 200 }}>
        <div style={{ height: '100%', width: `${scrolled * 100}%`, background: '#7abf2e', transition: 'width 0.1s linear' }} />
      </div>

      <div className="art">

        {/* ── TOP BAR ── */}
        <header className="art__back">
          <button className="art__back-btn" onClick={() => window.history.back()}>
            <FaArrowLeft size={9} /> Voltar
          </button>
          <span className="art__back-brand">DynaAgTech</span>
          <span className="art__back-issue">Análise Setorial · Blog DynaAgTech</span>
        </header>

        {/* ── HERO ── */}
        <section className="art__hero">
          <div className="art__hero-visual">
            <div style={{
              width: '100%', height: '100%',
              background: 'linear-gradient(160deg, #0e1a0e 0%, #1a2e10 40%, #0e1a0e 100%)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              position: 'relative', overflow: 'hidden',
            }}>
              <svg viewBox="0 0 900 420" style={{ width: '70%', maxWidth: 640, opacity: 0.2 }} fill="none">
                <ellipse cx="240" cy="340" rx="120" ry="120" stroke="#7abf2e" strokeWidth="6"/>
                <ellipse cx="240" cy="340" rx="60" ry="60" stroke="#7abf2e" strokeWidth="3"/>
                <ellipse cx="640" cy="360" rx="80" ry="80" stroke="#7abf2e" strokeWidth="6"/>
                <ellipse cx="640" cy="360" rx="38" ry="38" stroke="#7abf2e" strokeWidth="3"/>
                <rect x="300" y="240" width="300" height="100" rx="8" stroke="#7abf2e" strokeWidth="5"/>
                <rect x="340" y="180" width="160" height="70" rx="6" stroke="#7abf2e" strokeWidth="4"/>
                <rect x="600" y="280" width="80" height="80" rx="4" stroke="#7abf2e" strokeWidth="3"/>
                <line x1="360" y1="245" x2="560" y2="245" stroke="#7abf2e" strokeWidth="2" strokeDasharray="8 5"/>
                <circle cx="420" cy="210" r="8" fill="#7abf2e" opacity="0.8"/>
                <circle cx="460" cy="210" r="8" fill="#7abf2e" opacity="0.5"/>
                <circle cx="500" cy="210" r="8" fill="#7abf2e" opacity="0.3"/>
              </svg>
              <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 60% 60% at 50% 50%, transparent 40%, #0e1a0e 100%)' }}/>
              <div style={{ position: 'absolute', bottom: 32, left: '50%', transform: 'translateX(-50%)', fontFamily: "'JetBrains Mono', monospace", fontSize: '0.6rem', letterSpacing: '0.3em', textTransform: 'uppercase', color: 'rgba(122,191,46,0.4)' }}>
                Gestão de Frota · Eficiência Energética · Agro
              </div>
            </div>
          </div>

          <div className="art__hero-meta">
            <div className="art__hero-meta-cell">
              <span className="art__hero-meta-label">Categoria</span>
              <span className="art__hero-meta-value">Gestão de Custos Agrícolas</span>
            </div>
            <div className="art__hero-meta-cell">
              <span className="art__hero-meta-label">Contexto</span>
              <span className="art__hero-meta-value art__hero-meta-value--accent">Geopolítica & Campo</span>
            </div>
            <div className="art__hero-meta-cell">
              <span className="art__hero-meta-label">Foco</span>
              <span className="art__hero-meta-value">Eficiência de Combustível</span>
            </div>
          </div>
        </section>

        {/* ── TITLE BLOCK ── */}
        <div className="art__cover">
          <div className="art__kicker">Análise Setorial · Blog DynaAgTech</div>
          <h1 className="art__title">
            Diesel,<br />
            <em>Soberania</em><br />
            e a Conta que<br />
            o Produtor Paga.
          </h1>
          <p className="art__deck">
            Grandes usinas chegam a gastar 50 milhões de reais por ano só em diesel para abastecer frotas. Com o agravamento dos conflitos no Oriente Médio pressionando o petróleo, esse número não vai diminuir sozinho — mas parte dele está sob controle do produtor.
          </p>
          <div className="art__byline">
            <div className="art__byline-dot">AB</div>
            <div className="art__byline-text">
              <strong>André Bandeli · DynaAgTech</strong>
              Engenharia Agrícola · Mecanização · Sistemas Embarcados
            </div>
          </div>
        </div>

        {/* ── BODY ── */}
        <div className="art__body">

          {/* Cap 1 */}
          <div className="art__chapter">
            <div className="art__chapter-num"><span/>01</div>
            <div className="art__chapter-body">
              <h2 className="art__chapter-heading">O Paradoxo da<br /><em>Soberania Energética</em></h2>
              <p className="art__p">
                Fala-se muito em soberania nacional na agricultura. O Brasil é um dos maiores produtores de alimentos do mundo, com tecnologia de ponta, pesquisa de classe internacional e produtividade crescente. Mas, no que diz respeito à energia que move as máquinas desse mesmo campo, a dependência do mercado externo é significativa.
              </p>
              <p className="art__p">
                O produtor que controla cada detalhe da sua lavoura — variedade, fertilização, irrigação, colheita — não controla o preço do insumo que faz tudo isso funcionar. Ele paga o preço de decisões tomadas em outro continente.
              </p>
              <div className="art__pull">
                <p className="art__pull-text">O mercado externo não é controlável. Mas o que acontece da porteira para dentro, é.</p>
                <span className="art__pull-source">Princípio central · DynaAgTech</span>
              </div>
              <p className="art__p">
                Isso não é uma crítica à política energética em si. É uma constatação operacional: há um risco que não pode ser gerenciado pela porteira afora. Mas há outro, igualmente relevante, que pode — e que a maior parte das frotas agrícolas ainda não mede.
              </p>
              <div className="art__data">
                <div className="art__datum">
                  <div className="art__datum-label">Gasto anual em diesel</div>
                  <div className="art__datum-value">R$ 50M</div>
                  <div className="art__datum-sub">em grandes usinas sucroalcooleiras para abastecimento de frota</div>
                </div>
                <div className="art__datum">
                  <div className="art__datum-label">Potencial de redução</div>
                  <div className="art__datum-value">≤ 30%</div>
                  <div className="art__datum-sub">no consumo de combustível com monitoramento de eficiência</div>
                </div>
                <div className="art__datum">
                  <div className="art__datum-label">Patinagem ideal (ASABE)</div>
                  <div className="art__datum-value">8–12%</div>
                  <div className="art__datum-sub">faixa que maximiza transferência de torque ao solo</div>
                </div>
              </div>
            </div>
          </div>

          {/* Cap 2 */}
          <div className="art__chapter">
            <div className="art__chapter-num"><span/>02</div>
            <div className="art__chapter-body">
              <h2 className="art__chapter-heading">As Perdas Invisíveis<br /><em>da Operação Agrícola</em></h2>
              <p className="art__p">
                Quando o custo do diesel era baixo, as perdas operacionais relacionadas à ineficiência das máquinas eram toleráveis. Com a pressão atual sobre os custos, elas se tornam impossíveis de ignorar. Essas perdas têm origem em dois pontos principais, que a engenharia agrícola estuda com precisão.
              </p>
              <div className="art__steps">
                {[
                  { n: '1', title: 'O motor fora da faixa ideal', text: 'Um motor diesel operando fora da faixa de máxima eficiência térmica consome mais combustível para entregar a mesma potência. A dinamometria — técnica usada para medir torque e potência em bancada — permite identificar esse ponto e calibrar a operação para que o trator trabalhe nessa faixa. Na prática, a maior parte das frotas opera sem esse dado.' },
                  { n: '2', title: 'A patinagem que desperdiça potência', text: 'O deslizamento dos pneus quando o trator empurra o implemento contra a resistência do solo é uma das principais fontes de perda de eficiência em campo. Cada percentual de patinagem acima do ideal representa potência gerada pelo motor que não chega ao trabalho efetivo. Em condições severas, é comum encontrar operações com 20% a 30% ou mais de patinagem.' },
                ].map((s) => (
                  <div className="art__step" key={s.n}>
                    <div className="art__step-n">{s.n}</div>
                    <div><h4>{s.title}</h4><p>{s.text}</p></div>
                  </div>
                ))}
              </div>
              <div className="art__note">
                <div className="art__note-label">Contexto acadêmico</div>
                <p>Na Feagri (Unicamp), duas disciplinas trabalham exatamente esses dois pontos: Laboratório de Máquinas, que ensina a otimizar consumo via dinamometria, e Trator-Implemento, que quantifica a eficiência real no conjunto solo-trator-implemento. A relação entre elas é o que os engenheiros chamam de eficiência do conjunto — uma métrica que captura, de forma integrada, o quanto da energia que entra no motor se converte em trabalho útil no campo.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Cap 3 — dark */}
        <div className="art__body">
          <div className="art__chapter art__chapter--dark">
            <div className="art__dark-head">
              <span className="art__dark-head-kicker">03 · Por que ninguém mede</span>
              <div className="art__dark-head-line"/>
            </div>
            <h2 className="art__chapter-heading">Percepção<br /><em>Não É Dado.</em></h2>
            <p className="art__p">Um operador experiente percebe quando o trator está pesado, quando o motor está forçando ou quando os pneus estão patinando demais. Mas percepção não é dado. Sem medição sistemática, não há como saber com precisão quanto se está perdendo, em que condições as perdas são maiores, ou se as ações corretivas adotadas estão funcionando.</p>
            <p className="art__p">Além disso, a complexidade do problema dificulta a atribuição de causas. O consumo elevado de uma semana pode ser resultado de solo mais úmido, de um operador diferente, de um implemento com regulagem errada, ou de um motor que precisa de manutenção. Sem dados, tudo vira suposição — e suposição não é gestão.</p>
            <div className="art__metrics-dark">
              {[
                { value: 'Solo', label: 'Variável 1', sub: 'umidade e resistência alteram a patinagem turno a turno', color: '#7abf2e' },
                { value: 'Operador', label: 'Variável 2', sub: 'hábito e estilo de condução impactam o consumo horário', color: '#FFD100' },
                { value: 'Motor', label: 'Variável 3', sub: 'desgaste e regulagem afetam o ponto de eficiência térmica', color: '#5FC3E4' },
              ].map((m, i) => (
                <div className="art__metric-dark" key={i}>
                  <div className="art__metric-dark-value" style={{ color: m.color }}>{m.value}</div>
                  <div className="art__metric-dark-label">{m.label}</div>
                  <div className="art__metric-dark-sub">{m.sub}</div>
                </div>
              ))}
            </div>
            <div className="art__tech">
              {[
                { label: 'Diagnóstico', title: 'Curva de Torque', desc: 'Coleta e análise da curva de desempenho do motor: torque vs. rotação vs. consumo específico (BSFC). Identifica com precisão a faixa de operação de máxima eficiência térmica.' },
                { label: 'Campo', title: 'Auditoria Operacional', desc: 'Registro de dados reais: rotações utilizadas, relação de marchas, velocidade de trabalho e consumo horário. Cruzados com a curva do motor para mapear o desvio energético.' },
                { label: 'Resultado', title: 'Protocolo de Manejo', desc: 'Marcha recomendada, faixa de rotação alvo e parâmetros de patinagem por operação agrícola — baseados na curva real do motor do cliente. Aplicável imediatamente.' },
                { label: 'Próximo passo', title: 'IoT Embarcado', desc: 'Sistema em desenvolvimento que leva o diagnóstico para dentro da cabine em tempo real: alertas, score de eficiência e transmissão de dados por 4G e LoRa.' },
              ].map((t, i) => (
                <div className="art__tech-item" key={i}>
                  <div className="art__tech-label">{t.label}</div>
                  <div className="art__tech-title">{t.title}</div>
                  <div className="art__tech-desc">{t.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Cap 4 */}
        <div className="art__body">
          <div className="art__chapter">
            <div className="art__chapter-num"><span/>04</div>
            <div className="art__chapter-body">
              <h2 className="art__chapter-heading">O que a Medição<br /><em>Muda na Prática</em></h2>
              <p className="art__p">
                Quando se passa a monitorar rotação do motor, consumo instantâneo de combustível, velocidade real de deslocamento e velocidade teórica calculada a partir da rotação das rodas, é possível calcular em tempo real dois indicadores fundamentais: a eficiência do motor em relação à sua curva de potência e o percentual de patinagem em campo.
              </p>
              <div className="art__pull">
                <p className="art__pull-text">Em sistemas com esse tipo de monitoramento, é possível alcançar reduções de até 30% no consumo de combustível — sem trocar o trator, sem reduzir a área operada.</p>
              </div>
              <div className="art__game">
                {[
                  { emoji: '📊', title: 'Identificar onde se perde', text: 'Em quais operações as perdas são maiores, em que condições de solo e com quais configurações de implemento — dados que só a instrumentação contínua consegue revelar.' },
                  { emoji: '🔧', title: 'Ajustar com precisão', text: 'Regulagem do implemento, pressão dos pneus, seleção de marcha e rotação alvo passam a ser decisões baseadas em dados reais — não em estimativas ou hábito operacional.' },
                  { emoji: '🎯', title: 'Definir metas reais', text: 'Metas de consumo por hectare configuradas por tipo de operação, com base no histórico da própria frota. Desafiadoras, mas alcançáveis — o que sustenta o engajamento dos operadores.' },
                ].map((g, i) => (
                  <div className="art__game-item" key={i}>
                    <span className="art__game-emoji">{g.emoji}</span>
                    <div className="art__game-title">{g.title}</div>
                    <div className="art__game-text">{g.text}</div>
                  </div>
                ))}
              </div>
              <div className="art__note">
                <div className="art__note-label">Conclusão</div>
                <p>O ponto central não é tecnológico — é de gestão. O mercado de commodities energéticas não está sob controle do produtor. Mas a eficiência com que cada litro de diesel é convertido em trabalho produtivo, essa sim está. E enquanto essa variável permanecer invisível, o produtor está gerenciando apenas metade do problema.</p>
              </div>
            </div>
          </div>
        </div>

        {/* ── CTA ── */}
        <div className="art__cta">
          <h2 className="art__cta-heading">Capturar o invisível<br />e transformar<br /><em>em decisão.</em></h2>
          <div className="art__cta-right">
            <p className="art__cta-desc">O diagnóstico de curva de torque e auditoria operacional da DynaAgTech já estão disponíveis como serviço de consultoria. Os resultados são imediatos — sem aguardar hardware. Enquanto isso, o sistema embarcado está em desenvolvimento para levar esse controle para dentro de cada cabine.</p>
            <div className="art__cta-stack">
              <button className="art__cta-btn" onClick={() => openWhatsApp('Quero saber mais sobre o diagnóstico de eficiência de frota da DynaAgTech.')}>
                <FaWhatsapp size={12} /> Falar com a DynaAgTech
              </button>
              <a href="/" className="art__cta-btn--secondary">
                <FaArrowLeft size={10} /> Ver Todas as Soluções
              </a>
            </div>
          </div>
        </div>

        {/* ── FOOTER ── */}
        <footer className="art__footer">
          <span className="art__footer-note">© 2025 DynaAgTech · AgTech de Otimização Agrícola</span>
          <span className="art__footer-note">dynastartup.vercel.app</span>
        </footer>

      </div>
    </>
  );
}